var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewAgreement"},[_c('Header',{attrs:{"title":"查看协议"}}),_c('div',{staticClass:"main-viewAgreement"},[_c('viewAgreement',{ref:"Agreement",staticClass:"viewAgreement"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }